import React from "react";
import Form from "./Form.js";
import correctIcon from "./correct.svg";
import incorrectIcon from "./incorrect.svg";

export default function Item(props) {
  const { name, component, submitted, correct, submit } = props;
  const displayName = name.replace(/\s\(.+\)$/, "");
  const slug = encodeURIComponent(name.replace(/\s/g, "_"));
  return (
    <section>
      <div className="left">{component}</div>
      <div className="answer">
        {submitted ? (
          <div className="revealed">
            <span className="display-name">{displayName}</span>
            <a
              href={"https://en.wikipedia.org/wiki/" + slug}
              target="_blank"
              rel="noopener noreferrer"
              className="link"
            >
              en.wikipedia.org <span>⇱</span>
            </a>
            <img
              src={correct ? correctIcon : incorrectIcon}
              alt={correct ? "Correct" : "Incorrect"}
            />
          </div>
        ) : (
          <Form submit={submit} />
        )}
      </div>
    </section>
  );
}
